// Centralized route configuration
export const ROUTES = {
  VIEW: '/',
  EDIT: '/spg-edit',
  PUBLISH: '/spg-publish',
  SUBSCRIPTION: '/spg-subscription',
  PAGES: '/spg-pages',
  FILES: '/spg-files',
  AGENTS: '/spg-agents',
  DRAFTS: '/spg-drafts',
  SETTINGS: '/spg-settings',
  HISTORY: '/spg-history',
  NOT_FOUND: '/spg-notfound',
};
